
import cityList from "@/common/province.json";
const utils = {
    //验证身份证
    IdentityCodeValid(code) {
        var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
        var tip = "";
        var pass = true;

        if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
            tip = "身份证号格式错误";
            pass = false;
        }

        if (!city[code.substr(0, 2)]) {
            tip = "地址编码错误";
            pass = false;
        }
        if (code.length == 18) {
            var sBirthday = code.substr(6, 4) + "-" + Number(code.substr(10, 2)) + "-" + Number(code.substr(12, 2));
            var d = new Date(sBirthday.replace(/-/g, "/"))
            if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
                //alert("非法生日");
                pass = false;
            }
        }
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
                tip = "校验位错误";
                pass = false;
            }

        }
        return pass;
    },
    formData(fromdate) {
        if (fromdate != null) {
            var date = new Date(fromdate);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + m + '-' + d;
        }
    },
    //节流函数
    throttle(func, interval) {
        let timeout;
        let startTime = new Date();
        return function () {
            clearTimeout(timeout);
            let curTime = new Date();
            if (curTime - startTime <= interval) {
                //小于规定时间间隔时，用setTimeout在指定时间后再执行
                timeout = setTimeout(() => {
                    func();
                }, interval)
            } else {
                //重新计时并执行函数
                startTime = curTime;
                func()
            }
        }
    },
    //   省市区格式化
    formAddress(provCode, cityCode, areaCode) {
        if (!provCode) {
            return;
        }
        for (var i = 0; i < cityList.length; i++) {
            if (provCode == cityList[i].value) {
                provice = cityList[i].label
                if (cityCode) {
                    for (var m = 0; m < cityList[i].children.length; m++) {
                        if (cityCode == cityList[i].children[m].value) {
                            city = cityList[i].children[m].label;
                            if (areaCode) {
                                console.log(cityList[i].children[m].children.length)
                                for (var n = 0; n < cityList[i].children[m].children.length; n++) {
                                    if (areaCode == cityList[i].children[m].children[n].value) {
                                        area = cityList[i].children[m].children[n].label;
                                        return provice + '-' + city + '-' + area
                                    }
                                }
                            } else {
                                return provice + '-' + city
                            }
                        }
                    }
                } else {
                    return provice;
                }
            }
        }
        var provice, city, area;
        cityList.forEach(item1 => {

        })

    }

}
export default utils



// WEBPACK FOOTER //
// ./src/common/util.js